import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AppProvider } from '@/contexts/AppContext'
import { DialogProvider } from '@/contexts/DialogContext'
import { Layout } from '@/components/Layout'
import { EntitiesPage } from '@/pages/EntitiesPage'
import { EntityPage } from '@/pages/EntityPage'
import { ThreadPage } from '@/pages/ThreadPage'
import { ArchivioPage } from '@/pages/ArchivioPage'
// import { lazy, Suspense } from 'react'
import { TutorialsPage } from '@/pages/TutorialsPage'
import { HomePage } from '@/pages/HomePage'

// EmailExtractorPage removed

function App() {
  return (
    <AppProvider>
      <DialogProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="entities" element={<EntitiesPage />} />
              <Route path="entities/:entityId" element={<EntityPage />} />
              <Route path="entities/:entityId/threads/:threadId" element={<ThreadPage />} />

              <Route path="tutorials" element={<TutorialsPage />} />
              { /* Email Extractor route removed */ }

              <Route path="archivio" element={<ArchivioPage />} />
              <Route path="archivio/:entityId" element={<EntityPage readOnly />} />
              <Route path="archivio/:entityId/threads/:threadId" element={<ThreadPage readOnly />} />
            </Route>
          </Routes>
        </Router>
      </DialogProvider>
    </AppProvider>
  )
}

export default App